export const API_ERROR_MESSAGE_LIST_SEPARATOR = '; ';

export const API_ERROR_STATUS_CODE_PREFIX = '[';
export const API_ERROR_STATUS_CODE_SUFFIX = '] ';

export const API_ERROR_EMPTY_JSON_OBJECT = '{}';
